import { find } from 'lodash-es';
import qs from 'qs';

// /my_reports?ticker={...}#kpi-forecasts
const { ticker, kpi_id } = (() => {
  if (window.location.search.length > 0) {
    return qs.parse(window.location.search.slice(1));
  }

  return {};
})();

export const preselectedForecast = ticker ? { ticker, kpi_id } : null;
